import { FormattedMessage } from 'react-intl'

import { SparklesIcon } from '@gto/icons-react/outline/sparkles'
import { Typography } from '@gto/ui/typography'

export const WelcomeStep = () => {
  return (
    <div className="flex flex-col items-center gap-6 text-center">
      <div className="flex size-18 items-center justify-center rounded-full bg-primary-main/10 text-primary-main ring-1 ring-inset ring-primary-main/20">
        <SparklesIcon
          height={36}
          width={36}
        />
      </div>

      <Typography
        className="max-w-[440px] font-bold"
        color="text.primary"
        variant="h4"
      >
        <FormattedMessage id="onboarding.welcome.title" />
      </Typography>

      <Typography
        className="max-w-[480px]"
        color="text.secondary"
        variant="body1"
      >
        <FormattedMessage id="onboarding.welcome.lead" />
      </Typography>

      <Typography
        className="max-w-[440px]"
        color="text.secondary"
        variant="body2"
      >
        <FormattedMessage id="onboarding.welcome.body" />
      </Typography>
    </div>
  )
}
